import React from 'react'
import { Typography } from '@mui/material'
import Select from 'redesign/components/atoms/select'
import { Container, SelectContainer } from './styles'
import type { IndividualAbsenceTypeFieldsProps } from './types'

const IndividualAbsenceTypeFields: React.FC<IndividualAbsenceTypeFieldsProps> = ({
  individualAbsenceTypeFieldsProps,
}) => (
  <Container>
    {individualAbsenceTypeFieldsProps.map(({ selectTitle, key, ...inputProps }) => (
      <SelectContainer key={key}>
        <Typography color="textPrimary" variant="body1">
          {selectTitle}
        </Typography>
        <Select {...inputProps} />
      </SelectContainer>
    ))}
  </Container>
)

export default IndividualAbsenceTypeFields
